import React, { Component } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CupomGrafico from "../../pages/CupomGraficos";
import CuponsV2 from "../../pages/CuponsV2";

export default class ControlledTabs extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      key: "Graficos",
    };
  }

  render() {
    return (
      <div>
        <Tabs
          style={{ paddingTop: 7, marginTop: -1 }}
          id="controlled-tab-example"
          className="tabStyle"
          activeKey={this.state.key}
          onSelect={(key) => this.setState({ key })}
        >
          <Tab style={{ paddingLeft: 20 }} eventKey="Graficos" title="Gráficos">
            <CupomGrafico></CupomGrafico>
          </Tab>
          <Tab eventKey="Cuponsv2" title="Painel de Cupons">
            <CuponsV2></CuponsV2>
          </Tab>
        </Tabs>
      </div>
    );
  }
}
